(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-infinite-products"] && !Shopify.designMode) return;
  try {
    
  const initializeInfiniteProducts = (scope = document) => {
    scope.querySelectorAll('[data-codex-infinite-products]').forEach((root) => {
      if (root.dataset.infiniteBound === 'true') return;
      root.dataset.infiniteBound = 'true';

      const grid = root.querySelector('[data-infinite-grid]');
      const sentinel = root.querySelector('[data-infinite-sentinel]');
      const loadMore = root.querySelector('[data-infinite-load-more]');
      const actionLabel = root.querySelector('[data-infinite-action-label]');
      const spinner = root.querySelector('[data-infinite-spinner]');
      const liveRegion = root.querySelector('[data-infinite-live]');
      if (!grid || !sentinel || !loadMore || !root.dataset.nextUrl) return;

      const pageSize = Number(root.dataset.pageSize) || 12;
      const totalPages = Number(root.dataset.totalPages) || 1;
      const currentPage = Number(root.dataset.currentPage) || 1;
      const restartAtFirstPage = root.dataset.restartAtFirstPage === 'true' && currentPage > 1;
      const labels = {
        loadMore: root.dataset.labelLoadMore,
        loading: root.dataset.labelLoading,
        retry: root.dataset.labelRetry,
        complete: root.dataset.labelComplete,
        loaded: root.dataset.labelLoaded
      };
      const productHandleFromUrl = (value) => {
        if (!value) return '';
        try {
          const url = new URL(value, window.location.origin);
          const marker = '/products/';
          const markerIndex = url.pathname.indexOf(marker);
          if (markerIndex === -1) return '';
          return decodeURIComponent(url.pathname.slice(markerIndex + marker.length).split('/')[0]).toLowerCase();
        } catch (error) {
          return '';
        }
      };
      const productKey = (item) => {
        const handle = item.dataset.productHandle || productHandleFromUrl(item.querySelector('a[href*="/products/"]')?.href);
        return handle.toLowerCase();
      };
      const seenProducts = new Set();
      const currentProductHandle = root.dataset.currentProductHandle?.toLowerCase();
      if (currentProductHandle) seenProducts.add(currentProductHandle);

      const collectPageProducts = () => {
        const pageMain = document.getElementById('MainContent') || document.querySelector('main') || document;
        pageMain.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          if (root.contains(link)) return;
          const handle = productHandleFromUrl(link.href);
          if (handle) seenProducts.add(handle);
        });
      };

      collectPageProducts();
      const initialItems = Array.from(grid.querySelectorAll('[data-infinite-item]'));
      if (restartAtFirstPage) {
        initialItems.forEach((item) => item.remove());
      } else {
        initialItems.forEach((item) => {
          const key = productKey(item);
          if (key && seenProducts.has(key)) {
            item.remove();
            return;
          }
          if (key) seenProducts.add(key);
        });
      }
      const queuedPageCount = restartAtFirstPage ? totalPages : Math.max(totalPages - currentPage, 0);
      const pageQueue = Array.from({ length: queuedPageCount }, (_, index) => {
        if (restartAtFirstPage) return index + 1;
        return currentPage + index + 1;
      });
      let loading = false;
      let finished = false;
      let observer;

      const announce = (message) => {
        if (!liveRegion) return;
        liveRegion.textContent = '';
        window.setTimeout(() => { liveRegion.textContent = message; }, 20);
      };

      const setState = (state) => {
        sentinel.dataset.state = state;
        grid.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        if (actionLabel) {
          actionLabel.textContent = state === 'retry' ? labels.retry : labels.loadMore;
        }
        if (spinner) spinner.textContent = labels.loading;
      };

      const acceptUniqueItems = (items) => items.filter((item) => {
        const key = productKey(item);
        if (!key || seenProducts.has(key)) return false;
        seenProducts.add(key);
        return true;
      });

      const fetchPage = async (page) => {
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', root.dataset.sectionId);
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 12000);

        try {
          const response = await fetch(url.toString(), {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: controller.signal
          });
          if (!response.ok) throw new Error(`Request failed with ${response.status}`);
          const html = await response.text();
          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextRoot = parsedDocument.querySelector('[data-codex-infinite-products]');
          if (!nextRoot) throw new Error('Product section was missing');
          return Array.from(nextRoot.querySelectorAll('[data-infinite-item]'));
        } finally {
          window.clearTimeout(timeout);
        }
      };

      const fetchNextPage = async () => {
        const page = pageQueue.shift();
        if (!page) return [];

        try {
          return acceptUniqueItems(await fetchPage(page));
        } catch (error) {
          pageQueue.unshift(page);
          throw error;
        }
      };

      const finish = () => {
        finished = true;
        if (observer) observer.disconnect();
        setState('complete');
        announce(labels.complete);
        loadMore.remove();
        if (spinner) spinner.remove();
        const completeLabel = document.createElement('span');
        completeLabel.textContent = labels.complete;
        sentinel.insertBefore(completeLabel, liveRegion || null);
      };

      const isSentinelNearViewport = () => {
        const bounds = sentinel.getBoundingClientRect();
        return bounds.top <= window.innerHeight + 600 && bounds.bottom >= -600;
      };

      const appendNextItems = async () => {
        if (loading || finished) return;
        loading = true;
        setState('loading');

        try {
          collectPageProducts();
          const nextItems = await fetchNextPage();
          nextItems.forEach((item) => grid.appendChild(item));
          if (nextItems.length) announce(labels.loaded.replace('__COUNT__', String(nextItems.length)));

          if (!pageQueue.length) {
            finish();
          } else {
            setState('idle');
          }
        } catch (error) {
          setState('retry');
        } finally {
          loading = false;
          if (!finished && sentinel.dataset.state === 'idle') {
            window.setTimeout(() => {
              if (isSentinelNearViewport()) appendNextItems();
            }, 100);
          }
        }
      };

      loadMore.addEventListener('click', (event) => {
        event.preventDefault();
        appendNextItems();
      });

      const startInfiniteFeed = () => {
        if (!pageQueue.length) {
          finish();
          return;
        }

        setState('idle');
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting) && sentinel.dataset.state !== 'retry') {
            appendNextItems();
          }
        }, { rootMargin: '600px 0px', threshold: 0.01 });
        observer.observe(sentinel);
        if (isSentinelNearViewport()) appendNextItems();
      };

      startInfiniteFeed();
    });
  };

  initializeInfiniteProducts();
  document.addEventListener('shopify:section:load', (event) => initializeInfiniteProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ih-signs-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ih-signs-carousel')) {
    customElements.define('ih-signs-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.current = 0;
        this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.focused = false;
        this.inView = false;
        this.slides.slice(1).forEach(slide => { const image = slide.querySelector('img'); if (image) image.loading = 'eager'; });
        const options = { signal: this.controller.signal };
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); }); }, options);
        this.addEventListener('touchstart', event => {
          this.touchX = event.target.closest('a, button') ? null : event.changedTouches[0]?.clientX;
          this.touchY = event.changedTouches[0]?.clientY;
        }, { ...options, passive: true });
        this.addEventListener('touchend', event => {
          if (this.touchX == null) return;
          const point = event.changedTouches[0];
          const distance = point.clientX - this.touchX;
          const vertical = point.clientY - this.touchY;
          if (Math.abs(distance) > 45 && Math.abs(distance) > Math.abs(vertical) * 1.3) this.manual(this.current + (distance < 0 ? 1 : -1));
          this.touchX = null;
        }, { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest?.('[data-carousel-slide]');
          if (slide && this.contains(slide)) this.manual(Number(slide.dataset.index));
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.15 });
        this.observer.observe(this.querySelector('.ih-signs-carousel__stage'));
        this.classList.add('is-ready');
      }
      show(index, announce = false) {
        this.current = ((index % this.slides.length) + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, number) => {
          const active = number === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dataset.activeIndex = String(this.current);
        const status = this.querySelector('[data-carousel-status]');
        if (announce && status) status.textContent = this.slides[this.current].dataset.title;
      }
      manual(index) {
        this.show(index, true);
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        this.dataset.playing = 'false';
        if (!this.isConnected || this.slides.length < 2 || this.paused || this.focused || !this.inView || document.hidden) return;
        this.dataset.playing = 'true';
        this.timer = setTimeout(() => { this.show(this.current + 1); this.schedule(); }, this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ih-wellness-shopify-stores"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ih-store-switcher')) {
  customElements.define('ih-store-switcher', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const choices = Array.from(this.querySelectorAll('[data-store-choice]'));
      const select = (choice) => {
        choices.forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
        this.querySelectorAll('[data-store-panel]').forEach(panel => { panel.hidden = panel.dataset.storePanel !== choice.dataset.storeChoice; });
      };
      choices.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', event => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const next = choices[(index + (event.key === 'ArrowRight' ? 1 : -1) + choices.length) % choices.length];
          select(next);
          next.focus();
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('cart-items').forEach((cartItems) => {
        if (cartItems.dataset.nksFloatingReady === 'true') return;
        cartItems.dataset.nksFloatingReady = 'true';

        cartItems.addEventListener('click', (event) => {
          const backToTop = event.target.closest('.nks-cart-back-to-top');
          if (!backToTop || !cartItems.contains(backToTop)) return;

          window.scrollTo({
            top: 0,
            left: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          });
        });

        let topObserver;
        let footerObserver;
        const setupFloatingCheckout = () => {
          const topCheckout = cartItems.querySelector('.nks-cart-top-checkout');
          const floatingCheckout = cartItems.querySelector('.nks-cart-floating-checkout');
          const footerCheckout = document.getElementById('checkout');

          if (!topCheckout || !floatingCheckout || floatingCheckout.dataset.ready === 'true') return;

          topObserver?.disconnect();
          footerObserver?.disconnect();
          floatingCheckout.dataset.ready = 'true';
          let topCheckoutVisible = true;
          let footerCheckoutVisible = false;

          const updateFloatingCheckout = () => {
            floatingCheckout.hidden = topCheckoutVisible || footerCheckoutVisible;
          };

          topObserver = new IntersectionObserver(([entry]) => {
            topCheckoutVisible = entry.isIntersecting;
            updateFloatingCheckout();
          });

          topObserver.observe(topCheckout);

          if (footerCheckout) {
            footerObserver = new IntersectionObserver(([entry]) => {
              footerCheckoutVisible = entry.isIntersecting;
              updateFloatingCheckout();
            });

            footerObserver.observe(footerCheckout);
          }
        };

        setupFloatingCheckout();
        new MutationObserver(setupFloatingCheckout).observe(cartItems, { childList: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-collection-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nks-collection-hero-slider')) {
    class NksCollectionHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.mobileNextButtons = Array.from(this.querySelectorAll('[data-mobile-next]'));
        this.autoplayButton = this.querySelector('[data-autoplay-toggle]');
        this.status = this.querySelector('[data-status]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.interval = Number(this.dataset.interval) || 6000;
        this.mobileAutoplayEnabled = this.dataset.mobileAutoplay === 'true';
        this.mobileInterval = Number(this.dataset.mobileInterval) || 3000;
        this.mobileViewport = window.matchMedia('(max-width: 749px)');
        this.pausedByUser = false;
        this.isHovered = false;
        this.hasFocus = false;
        this.pointerStartX = null;
        this.resizeFrame = null;
        this.imageWarmupTimer = null;
        this.showRequestId = 0;
        this.onResize = () => {
          window.cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = window.requestAnimationFrame(() => this.normalizeHeadingWidths());
        };

        window.addEventListener('resize', this.onResize);
        window.requestAnimationFrame(() => this.normalizeHeadingWidths());
        document.fonts?.ready.then(() => this.normalizeHeadingWidths());

        if (this.slides.length < 2) return;

        this.onPrevious = () => this.show(this.currentIndex - 1, true);
        this.onNext = () => this.show(this.currentIndex + 1, true);
        this.onMobileNext = async (event) => {
          const restoreFocus = event.detail === 0;
          await this.show(this.currentIndex + 1, true);
          if (!restoreFocus) return;
          window.requestAnimationFrame(() => {
            this.slides[this.currentIndex]?.querySelector('[data-mobile-next]')?.focus({ preventScroll: true });
          });
        };
        this.onPointerDown = (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.pointerStartX = event.clientX;
        };
        this.onPointerUp = (event) => {
          if (this.pointerStartX === null) return;
          const distance = event.clientX - this.pointerStartX;
          this.pointerStartX = null;
          if (Math.abs(distance) < 48) return;
          this.show(distance < 0 ? this.currentIndex + 1 : this.currentIndex - 1, true);
        };
        this.onMouseEnter = () => {
          this.isHovered = true;
          if (!this.mobileViewport.matches) this.stopAutoplay();
        };
        this.onMouseLeave = () => {
          this.isHovered = false;
          this.startAutoplay();
        };
        this.onFocusIn = () => {
          this.hasFocus = true;
          this.stopAutoplay();
        };
        this.onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.hasFocus = false;
            this.startAutoplay();
          }
        };
        this.onVisibilityChange = () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        };
        this.onAutoplayBreakpointChange = () => this.restartAutoplay();

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.mobileNextButtons.forEach((button) => button.addEventListener('click', this.onMobileNext));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
        this.autoplayButton?.addEventListener('click', () => this.toggleAutoplay());
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('pointerup', this.onPointerUp);
        this.addEventListener('pointercancel', () => { this.pointerStartX = null; });
        this.addEventListener('mouseenter', this.onMouseEnter);
        this.addEventListener('mouseleave', this.onMouseLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileViewport.addEventListener('change', this.onAutoplayBreakpointChange);

        this.show(this.currentIndex, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.mobileNextButtons?.forEach((button) => button.removeEventListener('click', this.onMobileNext));
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('pointerup', this.onPointerUp);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileViewport?.removeEventListener('change', this.onAutoplayBreakpointChange);
        window.removeEventListener('resize', this.onResize);
        window.cancelAnimationFrame(this.resizeFrame);
        window.clearTimeout(this.imageWarmupTimer);
      }

      normalizeHeadingWidths() {
        const isDesktop = window.matchMedia('(min-width: 750px)').matches;

        this.querySelectorAll('[data-heading-ink]').forEach((ink) => {
          ink.style.removeProperty('--nks-heading-scale');
          if (!isDesktop) return;

          const line = ink.closest('.nks-collection-hero__heading-line');
          const naturalWidth = ink.offsetWidth;
          const targetWidth = Math.min(450, (line?.clientWidth || 0) * 0.76);
          if (!naturalWidth || !targetWidth) return;

          const scale = Math.min(1.8, Math.max(0.58, targetWidth / naturalWidth));
          ink.style.setProperty('--nks-heading-scale', scale.toFixed(4));
        });
      }

      loadSlideImages(slide, priority = 'auto') {
        slide.querySelectorAll('.nks-collection-hero__sign-image, .nks-collection-hero__image').forEach((image) => {
          if (priority === 'high') {
            image.loading = 'eager';
            image.fetchPriority = 'high';
          } else if (priority === 'low') {
            image.loading = 'eager';
            image.fetchPriority = 'low';
          }
        });

        slide.querySelectorAll('source[data-deferred-srcset]').forEach((source) => {
          source.srcset = source.dataset.deferredSrcset;
          source.removeAttribute('data-deferred-srcset');
        });

        slide.querySelectorAll('img[data-deferred-src]').forEach((image) => {
          if (image.dataset.deferredSrcset) {
            image.srcset = image.dataset.deferredSrcset;
            image.removeAttribute('data-deferred-srcset');
          }
          image.src = image.dataset.deferredSrc;
          image.removeAttribute('data-deferred-src');
        });
      }

      prepareSlideImages(slide, priority = 'auto') {
        const images = Array.from(
          slide.querySelectorAll('.nks-collection-hero__sign-image, .nks-collection-hero__image')
        ).filter((image) => window.getComputedStyle(image).display !== 'none');
        const pendingImages = images.map((image) => {
          const hasDeferredSource = Boolean(image.closest('picture')?.querySelector('source[data-deferred-srcset]'));
          const hasDeferredImage = image.hasAttribute('data-deferred-src');
          const isReady = () => (
            image.complete &&
            image.naturalWidth > 1 &&
            Boolean(image.currentSrc) &&
            !image.currentSrc.startsWith('data:')
          );
          if (!hasDeferredSource && !hasDeferredImage && isReady()) {
            return Promise.resolve(true);
          }

          return new Promise((resolve) => {
            let timeoutId;
            const finish = (ready) => {
              window.clearTimeout(timeoutId);
              image.removeEventListener('load', onLoad);
              image.removeEventListener('error', onError);
              resolve(ready);
            };
            const onLoad = () => finish(isReady());
            const onError = () => finish(false);
            image.addEventListener('load', onLoad, { once: true });
            image.addEventListener('error', onError, { once: true });
            timeoutId = window.setTimeout(() => finish(isReady()), 5000);
          });
        });

        this.loadSlideImages(slide, priority);
        return Promise.all(pendingImages).then((results) => results.every(Boolean));
      }

      scheduleNextSlideWarmup() {
        window.clearTimeout(this.imageWarmupTimer);
        if (this.slides.length < 2) return;

        this.imageWarmupTimer = window.setTimeout(() => {
          const nextIndex = (this.currentIndex + 1) % this.slides.length;
          this.prepareSlideImages(this.slides[nextIndex], 'low');
        }, 500);
      }

      async show(index, announce) {
        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        const targetSlide = this.slides[normalizedIndex];
        const requestId = ++this.showRequestId;

        targetSlide.setAttribute('aria-busy', 'true');
        const imagesReady = await this.prepareSlideImages(targetSlide, 'high');
        targetSlide.removeAttribute('aria-busy');
        if (requestId !== this.showRequestId) return false;
        this.currentIndex = normalizedIndex;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === normalizedIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.toggleAttribute('inert', !isActive);
          slide.querySelectorAll('[data-slide-link]').forEach((link) => {
            if (isActive) link.removeAttribute('tabindex');
            else link.setAttribute('tabindex', '-1');
          });
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === normalizedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', String(isActive));
        });

        if (announce && this.status) {
          const heading = this.slides[normalizedIndex].querySelector('.nks-collection-hero__heading')?.textContent?.trim() || '';
          this.status.textContent = `${normalizedIndex + 1} / ${this.slides.length}: ${heading}`;
        }

        if (announce) this.restartAutoplay();
        this.scheduleNextSlideWarmup();
        return true;
      }

      startAutoplay() {
        const isMobile = this.mobileViewport.matches;
        const autoplayEnabled = isMobile ? this.mobileAutoplayEnabled : this.autoplayEnabled;
        if (
          !autoplayEnabled ||
          this.pausedByUser ||
          (this.isHovered && !isMobile) ||
          this.hasFocus ||
          document.hidden ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) return;
        this.stopAutoplay();
        const interval = isMobile ? this.mobileInterval : this.interval;
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1, false), interval);
      }

      stopAutoplay() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      toggleAutoplay() {
        this.pausedByUser = !this.pausedByUser;
        if (document.activeElement === this.autoplayButton) this.hasFocus = false;
        this.autoplayButton.classList.toggle('is-paused', this.pausedByUser);
        this.autoplayButton.setAttribute(
          'aria-label',
          this.pausedByUser ? this.autoplayButton.dataset.playLabel : this.autoplayButton.dataset.pauseLabel
        );
        if (this.pausedByUser) this.stopAutoplay();
        else this.startAutoplay();
      }
    }

    customElements.define('nks-collection-hero-slider', NksCollectionHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-collection-navigation"] && !Shopify.designMode) return;
  try {
    
  const initializeNksCollectionCarousel = (scope = document) => {
    scope.querySelectorAll('.nks-collection-nav').forEach((root) => {
      if (root.dataset.carouselBound === 'true') return;
      root.dataset.carouselBound = 'true';

      const track = root.querySelector('[data-nks-collection-track]');
      const previous = root.querySelector('[data-nks-collection-prev]');
      const next = root.querySelector('[data-nks-collection-next]');
      if (!track || !previous || !next) return;

      const movement = () => Math.max(track.clientWidth * 0.82, 280);
      const move = (direction) => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const atEnd = track.scrollLeft >= maxScroll - 8;
        const atStart = track.scrollLeft <= 8;

        if (direction > 0 && atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direction < 0 && atStart) {
          track.scrollTo({ left: maxScroll, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: movement() * direction, behavior: 'smooth' });
        }
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let paused = false;
        let timer = window.setInterval(() => {
          if (!paused && document.visibilityState === 'visible') move(1);
        }, 4200);

        const pause = () => { paused = true; };
        const resume = () => { paused = false; };
        root.addEventListener('pointerenter', pause);
        root.addEventListener('pointerleave', resume);
        root.addEventListener('focusin', pause);
        root.addEventListener('focusout', resume);
        root.addEventListener('touchstart', pause, { passive: true });
        root.addEventListener('touchend', resume, { passive: true });
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) window.clearInterval(timer);
        }, { once: true });
      }
    });
  };

  initializeNksCollectionCarousel();
  document.addEventListener('shopify:section:load', (event) => initializeNksCollectionCarousel(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-project-estimator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nks-project-estimator]').forEach((estimator) => {
    if (estimator.dataset.initialized === 'true') return;
    estimator.dataset.initialized = 'true';

    const form = estimator.querySelector('form');
    const output = estimator.querySelector('[data-estimate-output]');
    const property = estimator.querySelector('[data-estimate-property]');
    const baseEstimate = Number(estimator.dataset.baseEstimate || 0);
    const buffer = Number(estimator.dataset.buffer || 0);
    const locale = estimator.dataset.locale || 'en-US';
    const currency = estimator.dataset.currency || 'USD';
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    });

    const format = (cents) => formatter.format(cents / 100);
    const update = () => {
      const checked = [...form.querySelectorAll('input[type="radio"][data-adjustment]:checked')];
      const adjustment = checked.reduce((sum, input) => sum + Number(input.dataset.adjustment || 0), 0);
      const low = baseEstimate + adjustment;
      const highRaw = low * (1 + buffer / 100);
      const high = Math.ceil(highRaw / 10000) * 10000;
      const range = `${format(low)}–${format(high)}`;
      output.textContent = range;
      property.value = range;
    };

    form.addEventListener('change', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-swipe-shop"]) return;
  try {
    
  if (!customElements.get('nks-swipe-shop')) {
    customElements.define('nks-swipe-shop', class extends HTMLElement {
      connectedCallback() {
        this.feed = this.querySelector('[data-swipe-feed]');
        if (!this.feed) return;
        this.profileKey = 'nksSwipeProfileV1';
        this.profile = { categories: {} };
        this.activeCard = null;
        this.activeSince = 0;
        this.canPersist = false;
        this.onboardingPlayed = false;
        this.onboardingToken = 0;
        this.nextUrl = this.dataset.nextUrl || '';
        this.sectionId = this.dataset.sectionId || '';
        this.loadingMore = false;
        this.removeDuplicates();
        this.cards = [...this.querySelectorAll('[data-swipe-card]')];
        this.refreshConsent();
        document.addEventListener('visitorConsentCollected', () => this.refreshConsent());
        this.bindVariants(this.cards);
        this.bindActions(this.cards);
        this.observeCards(this.cards);
        this.bindOnboarding();
      }

      disconnectedCallback() {
        clearTimeout(this.onboardingTimer);
        clearTimeout(this.viewTimer);
        this.onboardingToken += 1;
        this.observer?.disconnect();
        if (!this.boundCancelOnboarding) return;
        this.feed?.removeEventListener('pointerdown', this.boundCancelOnboarding);
        this.feed?.removeEventListener('touchstart', this.boundCancelOnboarding);
        this.feed?.removeEventListener('wheel', this.boundCancelOnboarding);
        this.feed?.removeEventListener('keydown', this.boundCancelOnboarding);
        window.removeEventListener('resize', this.boundOnboardingResize);
        document.removeEventListener('visibilitychange', this.boundOnboardingVisibility);
      }

      bindOnboarding() {
        const cue = this.querySelector('[data-swipe-onboarding]');
        if (!cue || !window.matchMedia('(max-width: 749px)').matches) return;
        this.boundCancelOnboarding = () => this.cancelOnboarding();
        this.boundOnboardingResize = () => {
          if (!window.matchMedia('(max-width: 749px)').matches) this.cancelOnboarding();
        };
        this.boundOnboardingVisibility = () => {
          if (document.hidden) this.cancelOnboarding();
        };
        this.feed.addEventListener('pointerdown', this.boundCancelOnboarding, { passive: true });
        this.feed.addEventListener('touchstart', this.boundCancelOnboarding, { passive: true });
        this.feed.addEventListener('wheel', this.boundCancelOnboarding, { passive: true });
        this.feed.addEventListener('keydown', this.boundCancelOnboarding);
        window.addEventListener('resize', this.boundOnboardingResize);
        document.addEventListener('visibilitychange', this.boundOnboardingVisibility);
        this.onboardingTimer = window.setTimeout(() => this.startOnboarding(), 3000);
      }

      cancelOnboarding() {
        clearTimeout(this.onboardingTimer);
        this.onboardingTimer = null;
        this.onboardingPlayed = true;
        this.onboardingToken += 1;
        this.classList.remove('is-onboarding-active', 'is-onboarding-motion');
      }

      async startOnboarding() {
        const firstCard = this.cards[0];
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (this.onboardingPlayed || !isMobile || !firstCard || this.feed.scrollTop > 2 || (this.activeCard && this.activeCard !== firstCard)) {
          this.cancelOnboarding();
          return;
        }

        this.onboardingPlayed = true;
        this.onboardingTimer = null;
        const token = ++this.onboardingToken;
        this.classList.add('is-onboarding-active');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          await this.onboardingDelay(1400, token);
          if (token === this.onboardingToken) this.classList.remove('is-onboarding-active');
          return;
        }

        const start = this.feed.scrollTop;
        const distance = Math.round(firstCard.getBoundingClientRect().height * 0.25);
        const target = Math.min(start + distance, this.feed.scrollHeight - this.feed.clientHeight);
        this.classList.add('is-onboarding-motion');

        if (!await this.onboardingDelay(140, token)) return;
        if (!await this.animateOnboardingScroll(start, target, 720, token)) return;
        if (!await this.onboardingDelay(260, token)) return;
        if (!await this.animateOnboardingScroll(target, start, 820, token)) return;

        this.feed.scrollTop = start;
        this.classList.remove('is-onboarding-motion');
        if (!await this.onboardingDelay(260, token)) return;
        if (token === this.onboardingToken) this.classList.remove('is-onboarding-active');
      }

      onboardingDelay(duration, token) {
        return new Promise((resolve) => {
          window.setTimeout(() => resolve(token === this.onboardingToken), duration);
        });
      }

      animateOnboardingScroll(from, to, duration, token) {
        return new Promise((resolve) => {
          const startedAt = performance.now();
          const step = (now) => {
            if (token !== this.onboardingToken) {
              resolve(false);
              return;
            }
            const progress = Math.min(1, (now - startedAt) / duration);
            const eased = progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;
            this.feed.scrollTop = from + ((to - from) * eased);
            if (progress < 1) window.requestAnimationFrame(step);
            else resolve(true);
          };
          window.requestAnimationFrame(step);
        });
      }

      removeDuplicates() {
        const handles = new Set();
        this.querySelectorAll('[data-swipe-card]').forEach((card) => {
          const handle = card.dataset.productHandle;
          if (handles.has(handle)) card.remove();
          else handles.add(handle);
        });
      }

      refreshConsent() {
        try {
          this.canPersist = Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.());
        } catch (error) {
          this.canPersist = false;
        }
        if (!this.canPersist) return;
        try {
          const saved = JSON.parse(localStorage.getItem(this.profileKey));
          if (saved?.categories) this.profile = saved;
        } catch (error) {
          this.profile = { categories: {} };
        }
      }

      saveProfile() {
        if (!this.canPersist) return;
        try { localStorage.setItem(this.profileKey, JSON.stringify(this.profile)); }
        catch (error) { this.canPersist = false; }
      }

      learn(category, amount) {
        const current = Number(this.profile.categories[category] || 0);
        this.profile.categories[category] = Math.max(-12, Math.min(24, current + amount));
        this.saveProfile();
      }

      publish(name, card, extra = {}) {
        const payload = { productId: card?.dataset.productId || '', productHandle: card?.dataset.productHandle || '', category: card?.dataset.category || '', position: Number(card?.dataset.position || 0), ...extra };
        try { window.Shopify?.analytics?.publish(`nks:${name}`, payload); }
        catch (error) { return; }
      }

      observeCards(cards) {
        if (!this.observer) {
          this.observer = new IntersectionObserver((entries) => {
            const active = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (active && active.intersectionRatio >= 0.72) this.activate(active.target);
          }, { root: this.feed, threshold: [0.72, 0.9] });
        }
        cards.forEach((card) => this.observer.observe(card));
      }

      activate(card) {
        if (card === this.activeCard) return;
        if (this.cards?.[0] && card !== this.cards[0]) this.cancelOnboarding();
        const now = Date.now();
        if (this.activeCard) {
          const dwellMs = now - this.activeSince;
          const category = this.activeCard.dataset.category;
          if (dwellMs < 1500) this.learn(category, -2);
          else if (dwellMs >= 7000) this.learn(category, 2);
          else if (dwellMs >= 4000) this.learn(category, 1);
          this.publish('swipe_completed', this.activeCard, { dwellMs });
        }
        clearTimeout(this.viewTimer);
        this.activeCard = card;
        this.activeSince = now;
        const activeIndex = this.cards.indexOf(card);
        if (activeIndex >= this.cards.length - 4) this.loadMore();
        this.viewTimer = setTimeout(() => {
          if (this.activeCard !== card) return;
          this.publish('swipe_viewed', card, { dwellMs: Date.now() - this.activeSince });
        }, 1200);
      }

      async loadMore() {
        if (this.loadingMore || !this.nextUrl || !this.sectionId) return;
        this.loadingMore = true;
        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('view', 'swipe');
          url.searchParams.set('section_id', this.sectionId);
          const response = await fetch(url.toString(), {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) throw new Error('pagination');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextShop = documentFragment.querySelector('nks-swipe-shop');
          if (!nextShop) throw new Error('pagination');

          const existingHandles = new Set(this.cards.map((card) => card.dataset.productHandle));
          const newCards = [...nextShop.querySelectorAll('[data-swipe-card]')].filter((card) => {
            const handle = card.dataset.productHandle;
            if (!handle || existingHandles.has(handle)) return false;
            existingHandles.add(handle);
            return true;
          });

          this.nextUrl = nextShop.dataset.nextUrl || '';
          if (!newCards.length) return;

          const fragment = document.createDocumentFragment();
          newCards.forEach((card) => fragment.append(card));
          this.feed.append(fragment);
          this.cards.push(...newCards);
          this.bindVariants(newCards);
          this.bindActions(newCards);
          this.observeCards(newCards);
        } catch (error) {
          return;
        } finally {
          this.loadingMore = false;
        }
      }

      bindVariants(cards) {
        cards.forEach((card) => card.querySelectorAll('[data-swipe-variant]').forEach((select) => {
          select.addEventListener('change', () => {
            const card = select.closest('[data-swipe-card]');
            const input = card.querySelector('[data-swipe-variant-input]');
            const buy = card.querySelector('[data-swipe-buy]');
            const price = card.querySelector('[data-swipe-price]');
            if (input) input.value = select.value;
            if (buy) buy.href = `${buy.dataset.buyPrefix}${select.value}:1`;
            if (price) price.textContent = select.selectedOptions[0]?.dataset.price || price.textContent;
            this.publish('variant_selected', card, { variantId: select.value });
          });
        }));
      }

      bindActions(cards) {
        cards.forEach((card) => card.querySelectorAll('.nks-swipe-card__form').forEach((form) => {
          form.addEventListener('ih:added-to-cart', (event) => {
            const card = form.closest('[data-swipe-card]');
            this.learn(card.dataset.category, 6);
            this.publish('swipe_add_to_cart', card, { variantId: event.detail.variantId });
          });
        }));

        cards.forEach((card) => card.querySelectorAll('[data-swipe-buy]').forEach((link) => link.addEventListener('click', () => {
          const card = link.closest('[data-swipe-card]');
          this.learn(card.dataset.category, 8);
          this.publish('swipe_buy_now', card, { variantId: link.href.match(/\/cart\/(\d+):1/)?.[1] || '' });
        })));
      }

    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nks-tent-configurator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nks-tent-configurator]').forEach((configurator) => {
    if (configurator.dataset.initialized === 'true') return;
    configurator.dataset.initialized = 'true';

    const variantsElement = configurator.querySelector('[data-tent-variants]');
    const variants = JSON.parse(variantsElement.textContent);
    const radios = [...configurator.querySelectorAll('[data-option-position] input[type="radio"]')];
    const preview = configurator.querySelector('[data-tent-preview]');
    const estimateOutput = configurator.querySelector('[data-tent-estimate]');
    const estimateInput = configurator.querySelector('[data-tent-estimate-input]');
    const configurationInput = configurator.querySelector('[data-tent-configuration]');
    const variantInput = configurator.querySelector('[data-tent-variant-id]');
    const bodyInput = configurator.querySelector('[data-tent-body]');
    const countOutput = configurator.querySelector('[data-configuration-count]');
    const selectedOutputs = [...configurator.querySelectorAll('[data-selected-option]')];
    const cards = [...configurator.querySelectorAll('[data-variant-card]')];
    const locale = configurator.dataset.locale || 'en-US';
    const currency = configurator.dataset.currency || 'USD';
    const buffer = Number(configurator.dataset.buffer || 0);
    const money = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    });

    const priceTable = {
      sizes: [
        Number(configurator.getAttribute('data-base-10x10') || 0),
        Number(configurator.getAttribute('data-base-10x15') || 0),
        Number(configurator.getAttribute('data-base-10x20') || 0),
      ],
      backWalls: [
        Number(configurator.getAttribute('data-back-10x10') || 0),
        Number(configurator.getAttribute('data-back-10x15') || 0),
        Number(configurator.getAttribute('data-back-10x20') || 0),
      ],
      sideWalls: Number(configurator.dataset.sideWalls || 0),
      twoFlags: Number(configurator.dataset.twoFlags || 0),
      tableCover: Number(configurator.dataset.tableCover || 0),
    };

    const getSelectedRadios = () => [1, 2, 3].map((position) => {
      const selected = configurator.querySelector(`[data-option-position="${position}"] input:checked`);
      return selected || null;
    });

    const getEstimate = ([sizeIndex, wallsIndex, extrasIndex]) => {
      let low = priceTable.sizes[sizeIndex] || 0;
      const backWall = priceTable.backWalls[sizeIndex] || 0;

      if (wallsIndex === 0) low += backWall;
      if (wallsIndex === 1) low += priceTable.sideWalls;
      if (wallsIndex === 2) low += backWall + priceTable.sideWalls;
      if (extrasIndex === 0) low += priceTable.twoFlags;
      if (extrasIndex === 1) low += priceTable.tableCover;
      if (extrasIndex === 3) low += priceTable.twoFlags + priceTable.tableCover;

      return {
        low,
        high: Math.ceil((low * (1 + buffer / 100)) / 5000) * 5000,
      };
    };

    const setPreview = (variant) => {
      const swapImage = () => {
        if (!preview || !variant.image) return;
        preview.removeAttribute('srcset');
        preview.removeAttribute('sizes');
        preview.src = variant.image;
        preview.alt = variant.alt || variant.title;
      };

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reduceMotion) {
        document.startViewTransition(swapImage);
      } else {
        swapImage();
      }
    };

    const update = ({ updateImage = true, updateUrl = true } = {}) => {
      const selectedRadios = getSelectedRadios();
      if (selectedRadios.some((radio) => !radio)) return;
      const selections = selectedRadios.map((radio) => radio.value);
      const selectionIndexes = selectedRadios.map((radio) => Number(radio.dataset.valueIndex));
      const variant = variants.find((item) => item.options.every((option, index) => option === selections[index]));
      if (!variant) return;

      const estimate = getEstimate(selectionIndexes);
      const estimateText = `${money.format(estimate.low / 100)}–${money.format(estimate.high / 100)}`;
      const configurationText = selections.join(' / ');
      const variantIndex = variants.findIndex((item) => item.id === variant.id);

      if (updateImage) setPreview(variant);
      estimateOutput.textContent = estimateText;
      estimateInput.value = estimateText;
      configurationInput.value = configurationText;
      variantInput.value = variant.id;
      bodyInput.value = `${configurator.dataset.configurationPrefix} ${configurationText}. ${configurator.dataset.estimatePrefix} ${estimateText}.`;
      selectedOutputs.forEach((output, index) => {
        const selected = configurator.querySelector(`[data-option-position="${index + 1}"] input:checked`);
        const localizedLabel = selected?.nextElementSibling?.querySelector('strong')?.textContent.trim();
        output.textContent = localizedLabel || selections[index];
      });
      countOutput.textContent = configurator.dataset.countTemplate.replace('__CURRENT__', String(variantIndex + 1));

      cards.forEach((card) => {
        const selected = card.dataset.variantCard === String(variant.id);
        card.classList.toggle('is-selected', selected);
        if (selected) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });

      if (updateUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    radios.forEach((radio) => radio.addEventListener('change', () => update()));

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const variant = variants.find((item) => String(item.id) === card.dataset.variantCard);
        if (!variant) return;

        variant.options.forEach((value, index) => {
          const radio = radios.find((item) => item.value === value && item.closest('[data-option-position]').dataset.optionPosition === String(index + 1));
          if (radio) radio.checked = true;
        });

        update();
        configurator.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });

    update({ updateImage: false, updateUrl: false });
  });

  } catch(e) { console.error(e); }
})();
})();
